export { reportTable, emptyTable } from '../NewCreditAnaCredit/styles';
export var tableWrap = {
  overflowX: 'auto',
  marginBottom: '2em'
};